(() => {
  if (window.bvColorMediaLoaded) return;
  window.bvColorMediaLoaded = true;

  const filename = (url) => {
    try {
      return decodeURIComponent(new URL(url, window.location.href).pathname.split('/').pop()).toLowerCase();
    } catch {
      return '';
    }
  };

  const showColorMedia = (sectionId, variant) => {
    if (!variant || variant.featured_media) return;

    const picker = document.getElementById(`variant-selects-${sectionId}`);
    const gallery = document.getElementById(`MediaGallery-${sectionId}`);
    const entry = window.BV_COLOR_MEDIA_MAP?.[picker?.dataset.productHandle];
    if (!gallery || !entry) return;

    const [optionIndex, images] = entry;
    const selectedColor = variant[`option${optionIndex + 1}`];
    const targetFilename = filename(images[selectedColor] || '');
    if (!targetFilename) return;

    const slide = Array.from(gallery.querySelectorAll('.product__media-list > li[data-media-id]'))
      .find((item) => filename(item.querySelector('img')?.getAttribute('src') || '') === targetFilename);
    if (!slide || slide.classList.contains('is-active')) return;
    gallery.setActiveMedia?.(slide.dataset.mediaId, false);
  };

  const initialize = () => {
    document.querySelectorAll('variant-selects[data-product-handle]').forEach((picker) => {
      let variant;
      try {
        variant = JSON.parse(picker.querySelector('[data-selected-variant]')?.textContent || 'null');
      } catch {
        return;
      }
      showColorMedia(picker.dataset.section, variant);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', initialize);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => showColorMedia(data.sectionId, data.variant));
  }
})();
